/**
 * Firestore notification inbox — notifications/{userId}/items/{itemId}
 * Writes are server-only (notification_handlers.send_notification).
 * Client: subscribe + mark read.
 */
import {
  collection,
  doc,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
  writeBatch,
} from 'firebase/firestore';
import { db } from '../firebase';

const ROOT = 'notifications';

function itemsCol(userId) {
  return collection(db, ROOT, userId, 'items');
}

export function subscribeNotifications(userId, onChange, onError) {
  if (!userId) {
    onChange([]);
    return () => {};
  }
  const q = query(itemsCol(userId), orderBy('createdAt', 'desc'), limit(80));
  return onSnapshot(
    q,
    (snap) => {
      const items = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
        createdAtMs: d.data().createdAt?.toMillis?.() ?? null,
      }));
      onChange(items);
    },
    (err) => {
      console.warn('subscribeNotifications:', err);
      onError?.(err);
      onChange([]);
    }
  );
}

export async function markNotificationRead(userId, itemId) {
  if (!userId || !itemId) return;
  await updateDoc(doc(db, ROOT, userId, 'items', itemId), {
    read: true,
    readAt: serverTimestamp(),
  });
}

export async function markAllNotificationsRead(userId) {
  if (!userId) return;
  const q = query(itemsCol(userId), where('read', '==', false), limit(50));
  const snap = await getDocs(q);
  if (snap.empty) return;
  const batch = writeBatch(db);
  snap.docs.forEach((d) => {
    batch.update(d.ref, { read: true, readAt: serverTimestamp() });
  });
  await batch.commit();
}
